import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  inject,
  Input,
  Output,
} from '@angular/core';
import { Product, ProductCode, SlotCode, isSlotCode } from '@mkp/shared/models';
import { isOfflineProductCode } from '@mkp/shared/util-product';
import { ExplainBenefitsWrapperStore } from './explain-benefits-wrapper.store';

@Component({
  selector: 'mkp-explain-benefits-wrapper',
  template: `<ng-content />`,
  styleUrl: './explain-benefits-wrapper.component.scss',
  providers: [ExplainBenefitsWrapperStore],
})
export class ExplainBenefitsWrapperComponent {
  private readonly explainBenefitsWrapperStore = inject(ExplainBenefitsWrapperStore);

  @HostBinding('class.is-clickable')
  protected isClickable = true;

  @Input() set product(product: Product) {
    this.explainBenefitsWrapperStore.setProduct(product);
  }

  @Input() set productCode(productCode: ProductCode | SlotCode) {
    if (isSlotCode(productCode) || isOfflineProductCode(productCode)) {
      this.isClickable = false;
      return;
    }

    this.isClickable = true;
    this.explainBenefitsWrapperStore.fetchProduct(productCode);
  }

  @Input() set isReadMode(isReadMode: boolean) {
    this.explainBenefitsWrapperStore.setIsReadMode(isReadMode);
  }

  @Output() handleSelectProduct: EventEmitter<Product['code']> = new EventEmitter();

  @HostListener('click')
  onClick() {
    this.explainBenefitsWrapperStore.openExplainBenefitsModal(() =>
      this.handleSelectProduct.emit()
    );
  }
}
